import { Autocomplete } from "@mui/material";
import styled from "styled-components";

interface IMargin {
  hasPermission: boolean;
}

interface StyledAutocompleteProps {
  $error?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const ContainerBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ContainerInputs = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 25px;
`;

export const ContainerInputsDate = styled.div<IMargin>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: ${(props) => (props.hasPermission ? 8 : 0)}px;

 

  && .MuiTextField-root {
    margin-top: 0 !important;
  }
`;

export const ContainerWithButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 12px;
  margin-top: 10px;
`;

export const StyledAutocomplete = styled(Autocomplete)<StyledAutocompleteProps>`
  & .MuiFormControl-root {
    margin-top: 10px !important;
  }

  & .MuiFormHelperText-root {
    margin-left: 0 !important;
  }

  & .MuiInputLabel-root {
    font-size: 14px !important;
    font-weight: 400;
    font-family: "Inter", sans-serif !important;
    color: #666666 !important;
    line-height: 1.1375em !important;
  }

  & .MuiAutocomplete-inputRoot {
    width: 325px;
    font-size: 14px !important;
    font-weight: 400;
    font-family: "Inter", sans-serif !important;
    color: #666666 !important;
    padding: 6px 4px 7px 7px !important;
  }

  & .MuiOutlinedInput-root {
    border-radius: 4px;
    padding: 5px;

    & fieldset {
      border-width: 2px;
      border-color: ${({ $error }) =>
        $error ? "#d32f2f !important" : "#d1dbe3 !important"};
    }

    &:hover fieldset {
      border-color: ${({ $error }) =>
        $error ? "#d32f2f !important" : "#cbcbcb !important"};
    }

    &.Mui-focused fieldset {
      border-color: ${({ $error }) =>
        $error ? "#d32f2f !important" : "#1d9bf0 !important"};
    }
  }

  & .MuiInputBase-root {
    display: flex;
    align-items: center;
  }

  & .MuiAutocomplete-endAdornment {
    position: relative;
    top: unset;
    right: unset;
    transform: none;
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;
